import React from "react";
import { useQuery } from "react-query";
import { getLegalTypes } from "./gateway";

export default function useGetAvailableLegalTypes() {
  return useQuery({
    queryFn: getLegalTypes,
    queryKey: "available-legalTypes",
  });
}
